export const AvatarSearchbarSearchIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.66 15.66L12.66 12.66"
        stroke="#737373"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.67 12.66C9.98 12.66 12.66 9.98 12.66 6.67C12.66 3.35 9.98 0.67 6.67 0.67C3.35 0.67 0.67 3.35 0.67 6.67C0.67 9.98 3.35 12.66 6.67 12.66Z"
        stroke="#737373"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
